
import Chart from 'chart.js';

export default function link(scope, element, attrs) {

    var defaultConfig = { data: [], text: 'N/A'};
    var doughnutConfig = (scope && scope.config) || defaultConfig;

    var config = ChartConfig(doughnutConfig);

    var ctx = element[0].getContext('2d');
    var myChart = new Chart(ctx, config);

    scope.$watch("config",function() {
        doughnutConfig = (scope && scope.config) || defaultConfig;
        myChart.destroy();
        
        var config = ChartConfig(doughnutConfig);
        var ctx = element[0].getContext('2d');
        myChart = new Chart(ctx, config);
    });

};

function ChartConfig(doughnutConfig){
    return {
        type: 'doughnut',
        data: doughnutConfig.data,
        options: {
            legend: {
                display: false
            },
            elements: {
                center: {
                    text: doughnutConfig.text,
                    color: '#2c3e50',
                    fontStyle: 'Arial',
                    sidePadding: 20
                }
            },
            scales: {
                xAxes: [{
                    display: false,
                    angleLines: {
                        display: false
                    },
                    gridLines : {
                        display : false,
                        drawBorder: false
                    },
                    ticks: {
                        beginAtZero:true,
                        scaleShowLabels: false
                    }
                }],
                yAxes: [{
                    display: false,
                    angleLines: {
                        display: false
                    },
                    gridLines : {
                        display : false,
                        drawBorder: false
                    },
                    ticks: {
                        beginAtZero:true,
                        scaleShowLabels: false
                    }
                }]
            }
        },
        plugins: [{
            beforeDraw: function(chart) {
                if (chart.config.options.elements.center) {
                    //Get ctx
                    var ctx = chart.chart.ctx;

                    var centerConfig = chart.config.options.elements.center;
                    var fontStyle = centerConfig.fontStyle || 'Arial';
                    var txt = centerConfig.text;
                    var color = centerConfig.color || '#000';
                    var sidePadding = centerConfig.sidePadding || 20;
                    var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);

                    ctx.font = "30px " + fontStyle;

                    var stringWidth = ctx.measureText(txt).width;
                    var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

                    var widthRatio = elementWidth / stringWidth;
                    var newFontSize = Math.floor(30 * widthRatio);
                    var elementHeight = (chart.innerRadius * 2);

                    var fontSizeToUse = Math.min(newFontSize, elementHeight);

                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
                    var centerY = 1.06*((chart.chartArea.top + chart.chartArea.bottom) / 2);
                    ctx.font = fontSizeToUse + "px " + fontStyle;
                    ctx.fillStyle = color;

                    ctx.fillText(txt, centerX, centerY);
                }
            }
        }]
    };
}



// WEBPACK FOOTER //
// ./src/directive/doughnut-text-inside/doughnut-text-inside.link.js